import './assets/styles/main.css';
import { createApp } from 'vue';
import '@/api/config';
import '@/configs/realTime';
import router from './router';
import { i18n } from './locales/config';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import { useAppUpdate } from '@/composables/appUpdate';

const app = createApp(App);
Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
                hooks: ['mount', 'update', 'unmount'],
            },
        }),
    ],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [import.meta.env.VITE_APP_URL],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
    environment: import.meta.env.VITE_APP_ENV,
});

window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();

    const { notifyUpdateAvailable } = useAppUpdate();
    notifyUpdateAvailable();
});

app.use(i18n);
app.use(router);
app.mount('#app');
